import React, { useState } from "react";
import { pdfjs, Document, Page } from "react-pdf/dist/entry.webpack";
import { Modal, Button } from "react-bootstrap";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const EvidenceReader = ({ fileUrl, user }) => {
  const [numPages, setNumPages] = useState(0);
  const [previewMode, setPreviewMode] = useState(false);
  const [mdShow, setMdShow] = useState(false);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  // Ensure fileUrl is a valid string before calling toLowerCase()
  const isValidFile = typeof fileUrl === "string" && fileUrl.trim() !== "";
  const isPDF = isValidFile && fileUrl.toLowerCase().endsWith(".pdf");
  const isImage =
    isValidFile &&
    (fileUrl.toLowerCase().endsWith(".jpg") ||
      fileUrl.toLowerCase().endsWith(".jpeg") ||
      fileUrl.toLowerCase().endsWith(".png"));

  return (
    <div style={{ marginBottom: "10px", marginTop: "10px" }}>
      {isValidFile ? (
        <button
          type="button"
          className="btn btn-outline-info btn-icon-text"
          onClick={() => {
            setPreviewMode(true);
            setMdShow(true);
          }}
        >
          Preview File
        </button>
      ) : (
        <p style={{ color: "red" }}>No file available for preview.</p>
      )}

      {previewMode && isValidFile && (
        <button
          type="button"
          className="btn btn-outline-info btn-icon-text"
          onClick={() => {
            setPreviewMode(false);
            setMdShow(false);
          }}
        >
          {" "}
          Close Preview{" "}
        </button>
      )}

      <div className="clearfix"></div>

      {previewMode && (
        <div>
          <Modal
            size={isPDF ? "lg" : "md"}
            show={mdShow}
            onHide={() => {
              setPreviewMode(false);
              setMdShow(false);
            }}
            aria-labelledby="example-modal-sizes-title-md"
          >
            <Modal.Header closeButton></Modal.Header>

            <Modal.Body>
              {isPDF ? (
                <Document
                  file={fileUrl}
                  options={{ workerSrc: "/pdf.worker.js" }}
                  onLoadSuccess={onDocumentLoadSuccess}
                >
                  {Array.from(new Array(numPages), (el, index) => (
                    <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                  ))}
                </Document>
              ) : isImage ? (
                <img
                  src={fileUrl}
                  alt="Uploaded Receipt"
                  style={{ width: "100%", height: "auto" }}
                />
              ) : (
                <p style={{ color: "red", textAlign: "center" }}>Unsupported file type.</p>
              )}
            </Modal.Body>

            <Modal.Footer className="fleex-wrap">
              <Button
                variant="success"
                className="text-center"
                onClick={() => {
                  setMdShow(false);
                  setPreviewMode(false);
                }}
              >
                Close Preview
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      )}
    </div>
  );
};

export default EvidenceReader;
